<template>
  <div v-if="loading || this.report.length !== 0">
    <global-map
      :report="report">
    </global-map>
    <report-table
      :report="report" 
      :stats="processedOptions.stats" 
      :fields="processedOptions.fields"
      :current-page="currentPage"
      :per-page="perPage"
      :synced-with-graph="true">
      <template slot="geo_country" slot-scope="data">
        {{ getCountryFlag(data.item.geo_country) }} &nbsp;&nbsp; {{ data.item.geo_country }}
      </template>
    </report-table>
    <hr class="m-0 border-border" />
    <b-pagination 
      v-if="perPage > 0 && report.length > 0" 
      class="mt-3"
      :total-rows="report.length" 
      align="center" 
      v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
  </div>
  <no-results v-else></no-results>
</template>

<script>
import { reportView } from '@/reports/components/mixins/reportView'
import ReportTable from '@/reports/components/ReportTable'
import GlobalMap from '@/reports/components/maps/GlobalMap'
import { flag } from 'country-emoji'
import countries from 'i18n-iso-countries'
import NoResults from '@/components/NoResults'
import { getDefaultPriceField, getDefaultAveragePriceField } from '@/reports/components/ReportUtils'
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export default {
  name: 'GlobalView',
  data () {
    return {
      perPage: 10,
      currentPage: 1,
    }
  },
  methods: {
    processOptions (oldOptions) {
      let options = JSON.parse(JSON.stringify(oldOptions))
      options.fields.push('geo_country')
      options.stats.push('unique_users')
      options.stats.push('bids')
      options.stats.push('clears')
      options.stats.push(getDefaultAveragePriceField())
      options.stats.push(getDefaultPriceField())
      return options
    },
    getCountryFlag (countryCode) {
      return flag(countries.alpha3ToAlpha2(countryCode))
    }
  },
  created () {
    console.log('globalism')
  },
  mixins: [
    reportView
  ],
  components: {
    ReportTable,
    GlobalMap,
    NoResults
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/maps/GlobalView.vue